/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * Do not edit directly
 * Generated on Tue, 17 Mar 2020 04:33:48 GMT
 */

const colorButtonHuePrimary = "#0366d6";
const colorButtonHueSecondary = "#28a745";
const colorButtonHueTertiary = "#6f42c1";
const colorButtonHueDanger = "#d73a49";
const colorButtonHueWarning = "#ffd33d";
const colorButtonHueDisabled = "#959da5";
const colorButtonFocusedShadowPrimary = "#0366d680";
const colorButtonFocusedShadowSecondary = "#28a74580";
const colorButtonFocusedShadowTertiary = "#6f42c180";
const colorButtonFocusedShadowDanger = "#d73a4980";
const colorButtonFocusedShadowWarning = "#ffd33d80";
const colorButtonContrastPrimary = "rgb(255, 255, 255)";
const colorButtonContrastSecondary = "rgb(255, 255, 255)";
const colorButtonContrastTertiary = "rgb(255, 255, 255)";
const colorButtonContrastDanger = "rgb(255, 255, 255)";
const colorButtonContrastWarning = "rgb(255, 255, 255)";
const colorButtonContrastDisabled = "rgb(255, 255, 255)";
const colorGray100 = "#f6f8fa";
const colorGray200 = "#e1e4e8";
const colorGray300 = "#d1d5da";
const colorGray400 = "#959da5";
const colorGray500 = "#6a737d";
const colorGray600 = "#586069";
const colorGray700 = "#444d56";
const colorGray800 = "#2f363d";
const colorGray900 = "#24292e";
const colorGray = "#6a737d";
const colorGray000 = "#fafbfc";
const colorBlue100 = "#dbedff";
const colorBlue200 = "#c8e1ff";
const colorBlue300 = "#79b8ff";
const colorBlue400 = "#2188ff";
const colorBlue500 = "#0366d6";
const colorBlue600 = "#005cc5";
const colorBlue700 = "#044289";
const colorBlue800 = "#032f62";
const colorBlue900 = "#05264c";
const colorBlue = "#0366d6";
const colorBlue000 = "#f1f8ff";
const colorGreen100 = "#dcffe4";
const colorGreen200 = "#bef5cb";
const colorGreen300 = "#85e89d";
const colorGreen400 = "#34d058";
const colorGreen500 = "#28a745";
const colorGreen600 = "#22863a";
const colorGreen700 = "#176f2c";
const colorGreen800 = "#165c26";
const colorGreen900 = "#144620";
const colorGreen = "#28a745";
const colorGreen000 = "#f0fff4";
const colorYellow100 = "#fffbdd";
const colorYellow200 = "#fff5b1";
const colorYellow300 = "#ffea7f";
const colorYellow400 = "#ffdf5d";
const colorYellow500 = "#ffd33d";
const colorYellow600 = "#f9c513";
const colorYellow700 = "#dbab09";
const colorYellow800 = "#b08800";
const colorYellow900 = "#735c0f";
const colorYellow = "#ffd33d";
const colorYellow000 = "#fffdef";
const colorOrange100 = "#ffebda";
const colorOrange200 = "#ffd1ac";
const colorOrange300 = "#ffab70";
const colorOrange400 = "#fb8532";
const colorOrange500 = "#f66a0a";
const colorOrange600 = "#e36209";
const colorOrange700 = "#d15704";
const colorOrange800 = "#c24e00";
const colorOrange900 = "#a04100";
const colorOrange = "#f66a0a";
const colorOrange000 = "#fff8f2";
const colorRed100 = "#ffdce0";
const colorRed200 = "#fdaeb7";
const colorRed300 = "#f97583";
const colorRed400 = "#ea4a5a";
const colorRed500 = "#d73a49";
const colorRed600 = "#cb2431";
const colorRed700 = "#b31d28";
const colorRed800 = "#9e1c23";
const colorRed900 = "#86181d";
const colorRed = "#d73a49";
const colorRed000 = "#ffeef0";
const colorPurple100 = "#e6dcfd";
const colorPurple200 = "#d1bcf9";
const colorPurple300 = "#b392f0";
const colorPurple400 = "#8a63d2";
const colorPurple500 = "#6f42c1";
const colorPurple600 = "#5a32a3";
const colorPurple700 = "#4c2889";
const colorPurple800 = "#3a1d6e";
const colorPurple900 = "#29134e";
const colorPurple = "#6f42c1";
const colorPurple000 = "#f5f0ff";
const colorPink100 = "#fedbf0";
const colorPink200 = "#f9b3dd";
const colorPink300 = "#f692ce";
const colorPink400 = "#ec6cb9";
const colorPink500 = "#ea4aaa";
const colorPink600 = "#d03592";
const colorPink700 = "#b93a86";
const colorPink800 = "#99306f";
const colorPink900 = "#6d224f";
const colorPink = "#ea4aaa";
const colorPink000 = "#ffeef8";
const colorBlack = "rgb(27, 31, 35)";
const colorBlackFade15 = "rgba(27, 31, 35, 0.15)";
const colorBlackFade30 = "rgba(27, 31, 35, 0.30)";
const colorBlackFade50 = "rgba(27, 31, 35, 0.50)";
const colorBlackFade70 = "rgba(27, 31, 35, 0.70)";
const colorBlackFade85 = "rgba(27, 31, 35, 0.85)";
const colorWhite = "rgb(255, 255, 255)";
const colorWhiteFade15 = "rgba(255, 255, 255, 0.15)";
const colorWhiteFade30 = "rgba(255, 255, 255, 0.30)";
const colorWhiteFade50 = "rgba(255, 255, 255, 0.50)";
const colorWhiteFade70 = "rgba(255, 255, 255, 0.70)";
const colorWhiteFade85 = "rgba(255, 255, 255, 0.85)";
const colorTextPrimary = "#05264c";
const colorTextSecondary = "#22863a";
const colorTextTertiary = "#4c2889";
const colorTextInfo = "#005cc5";
const colorTextWarning = "#f9c513";
const colorTextDanger = "#cb2431";

var colorVariables = /*#__PURE__*/Object.freeze({
    __proto__: null,
    colorButtonHuePrimary: colorButtonHuePrimary,
    colorButtonHueSecondary: colorButtonHueSecondary,
    colorButtonHueTertiary: colorButtonHueTertiary,
    colorButtonHueDanger: colorButtonHueDanger,
    colorButtonHueWarning: colorButtonHueWarning,
    colorButtonHueDisabled: colorButtonHueDisabled,
    colorButtonFocusedShadowPrimary: colorButtonFocusedShadowPrimary,
    colorButtonFocusedShadowSecondary: colorButtonFocusedShadowSecondary,
    colorButtonFocusedShadowTertiary: colorButtonFocusedShadowTertiary,
    colorButtonFocusedShadowDanger: colorButtonFocusedShadowDanger,
    colorButtonFocusedShadowWarning: colorButtonFocusedShadowWarning,
    colorButtonContrastPrimary: colorButtonContrastPrimary,
    colorButtonContrastSecondary: colorButtonContrastSecondary,
    colorButtonContrastTertiary: colorButtonContrastTertiary,
    colorButtonContrastDanger: colorButtonContrastDanger,
    colorButtonContrastWarning: colorButtonContrastWarning,
    colorButtonContrastDisabled: colorButtonContrastDisabled,
    colorGray100: colorGray100,
    colorGray200: colorGray200,
    colorGray300: colorGray300,
    colorGray400: colorGray400,
    colorGray500: colorGray500,
    colorGray600: colorGray600,
    colorGray700: colorGray700,
    colorGray800: colorGray800,
    colorGray900: colorGray900,
    colorGray: colorGray,
    colorGray000: colorGray000,
    colorBlue100: colorBlue100,
    colorBlue200: colorBlue200,
    colorBlue300: colorBlue300,
    colorBlue400: colorBlue400,
    colorBlue500: colorBlue500,
    colorBlue600: colorBlue600,
    colorBlue700: colorBlue700,
    colorBlue800: colorBlue800,
    colorBlue900: colorBlue900,
    colorBlue: colorBlue,
    colorBlue000: colorBlue000,
    colorGreen100: colorGreen100,
    colorGreen200: colorGreen200,
    colorGreen300: colorGreen300,
    colorGreen400: colorGreen400,
    colorGreen500: colorGreen500,
    colorGreen600: colorGreen600,
    colorGreen700: colorGreen700,
    colorGreen800: colorGreen800,
    colorGreen900: colorGreen900,
    colorGreen: colorGreen,
    colorGreen000: colorGreen000,
    colorYellow100: colorYellow100,
    colorYellow200: colorYellow200,
    colorYellow300: colorYellow300,
    colorYellow400: colorYellow400,
    colorYellow500: colorYellow500,
    colorYellow600: colorYellow600,
    colorYellow700: colorYellow700,
    colorYellow800: colorYellow800,
    colorYellow900: colorYellow900,
    colorYellow: colorYellow,
    colorYellow000: colorYellow000,
    colorOrange100: colorOrange100,
    colorOrange200: colorOrange200,
    colorOrange300: colorOrange300,
    colorOrange400: colorOrange400,
    colorOrange500: colorOrange500,
    colorOrange600: colorOrange600,
    colorOrange700: colorOrange700,
    colorOrange800: colorOrange800,
    colorOrange900: colorOrange900,
    colorOrange: colorOrange,
    colorOrange000: colorOrange000,
    colorRed100: colorRed100,
    colorRed200: colorRed200,
    colorRed300: colorRed300,
    colorRed400: colorRed400,
    colorRed500: colorRed500,
    colorRed600: colorRed600,
    colorRed700: colorRed700,
    colorRed800: colorRed800,
    colorRed900: colorRed900,
    colorRed: colorRed,
    colorRed000: colorRed000,
    colorPurple100: colorPurple100,
    colorPurple200: colorPurple200,
    colorPurple300: colorPurple300,
    colorPurple400: colorPurple400,
    colorPurple500: colorPurple500,
    colorPurple600: colorPurple600,
    colorPurple700: colorPurple700,
    colorPurple800: colorPurple800,
    colorPurple900: colorPurple900,
    colorPurple: colorPurple,
    colorPurple000: colorPurple000,
    colorPink100: colorPink100,
    colorPink200: colorPink200,
    colorPink300: colorPink300,
    colorPink400: colorPink400,
    colorPink500: colorPink500,
    colorPink600: colorPink600,
    colorPink700: colorPink700,
    colorPink800: colorPink800,
    colorPink900: colorPink900,
    colorPink: colorPink,
    colorPink000: colorPink000,
    colorBlack: colorBlack,
    colorBlackFade15: colorBlackFade15,
    colorBlackFade30: colorBlackFade30,
    colorBlackFade50: colorBlackFade50,
    colorBlackFade70: colorBlackFade70,
    colorBlackFade85: colorBlackFade85,
    colorWhite: colorWhite,
    colorWhiteFade15: colorWhiteFade15,
    colorWhiteFade30: colorWhiteFade30,
    colorWhiteFade50: colorWhiteFade50,
    colorWhiteFade70: colorWhiteFade70,
    colorWhiteFade85: colorWhiteFade85,
    colorTextPrimary: colorTextPrimary,
    colorTextSecondary: colorTextSecondary,
    colorTextTertiary: colorTextTertiary,
    colorTextInfo: colorTextInfo,
    colorTextWarning: colorTextWarning,
    colorTextDanger: colorTextDanger
});

/**
 * Do not edit directly
 * Generated on Tue, 17 Mar 2020 04:33:48 GMT
 */

const sizeBreakpointXs = "0px";
const sizeBreakpointSm = "600px";
const sizeBreakpointMd = "960px";
const sizeBreakpointLg = "1280px";
const sizeBreakpointXl = "1920px";
const sizeButtonFontXs = "10px";
const sizeButtonFontSm = "11px";
const sizeButtonFontMd = "13px";
const sizeButtonFontLg = "15px";
const sizeButtonFontXl = "18px";
const sizeButtonFocusedShadowXs = "2px";
const sizeButtonFocusedShadowSm = "2px";
const sizeButtonFocusedShadowMd = "3px";
const sizeButtonFocusedShadowLg = "3px";
const sizeButtonFocusedShadowXl = "4px";
const sizeButtonBorderWidthXs = "1px";
const sizeButtonBorderWidthSm = "1.5px";
const sizeButtonBorderWidthMd = "2px";
const sizeButtonBorderWidthLg = "2.5px";
const sizeButtonBorderWidthXl = "3px";
const sizeButtonPaddingVerticalXs = "10px";
const sizeButtonPaddingVerticalSm = "11px";
const sizeButtonPaddingVerticalMd = "13px";
const sizeButtonPaddingVerticalLg = "16px";
const sizeButtonPaddingVerticalXl = "18px";
const sizeButtonPaddingHorizontalXs = "30px";
const sizeButtonPaddingHorizontalSm = "33px";
const sizeButtonPaddingHorizontalMd = "39px";
const sizeButtonPaddingHorizontalLg = "48px";
const sizeButtonPaddingHorizontalXl = "54px";
const sizeSpacing0 = "0px";
const sizeSpacing1 = "4px";
const sizeSpacing2 = "8px";
const sizeSpacing3 = "16px";
const sizeSpacing4 = "32px";
const sizeSpacing5 = "64px";
const sizeSpacing6 = "128px";
const sizeSpacing7 = "256px";
const sizeSpacing8 = "512px";
const sizeTextXs = "12px";
const sizeTextSm = "14px";
const sizeTextMd = "16px";
const sizeTextLg = "22px";
const sizeTextXl = "26px";
const sizeFontWeight100 = "100px";
const sizeFontWeight200 = "200px";
const sizeFontWeight300 = "300px";
const sizeFontWeight400 = "400px";
const sizeFontWeight500 = "500px";
const sizeFontWeight600 = "600px";
const sizeFontWeight700 = "700px";
const sizeFontWeight800 = "800px";
const sizeFontWeight900 = "900px";

var sizeVariables = /*#__PURE__*/Object.freeze({
    __proto__: null,
    sizeBreakpointXs: sizeBreakpointXs,
    sizeBreakpointSm: sizeBreakpointSm,
    sizeBreakpointMd: sizeBreakpointMd,
    sizeBreakpointLg: sizeBreakpointLg,
    sizeBreakpointXl: sizeBreakpointXl,
    sizeButtonFontXs: sizeButtonFontXs,
    sizeButtonFontSm: sizeButtonFontSm,
    sizeButtonFontMd: sizeButtonFontMd,
    sizeButtonFontLg: sizeButtonFontLg,
    sizeButtonFontXl: sizeButtonFontXl,
    sizeButtonFocusedShadowXs: sizeButtonFocusedShadowXs,
    sizeButtonFocusedShadowSm: sizeButtonFocusedShadowSm,
    sizeButtonFocusedShadowMd: sizeButtonFocusedShadowMd,
    sizeButtonFocusedShadowLg: sizeButtonFocusedShadowLg,
    sizeButtonFocusedShadowXl: sizeButtonFocusedShadowXl,
    sizeButtonBorderWidthXs: sizeButtonBorderWidthXs,
    sizeButtonBorderWidthSm: sizeButtonBorderWidthSm,
    sizeButtonBorderWidthMd: sizeButtonBorderWidthMd,
    sizeButtonBorderWidthLg: sizeButtonBorderWidthLg,
    sizeButtonBorderWidthXl: sizeButtonBorderWidthXl,
    sizeButtonPaddingVerticalXs: sizeButtonPaddingVerticalXs,
    sizeButtonPaddingVerticalSm: sizeButtonPaddingVerticalSm,
    sizeButtonPaddingVerticalMd: sizeButtonPaddingVerticalMd,
    sizeButtonPaddingVerticalLg: sizeButtonPaddingVerticalLg,
    sizeButtonPaddingVerticalXl: sizeButtonPaddingVerticalXl,
    sizeButtonPaddingHorizontalXs: sizeButtonPaddingHorizontalXs,
    sizeButtonPaddingHorizontalSm: sizeButtonPaddingHorizontalSm,
    sizeButtonPaddingHorizontalMd: sizeButtonPaddingHorizontalMd,
    sizeButtonPaddingHorizontalLg: sizeButtonPaddingHorizontalLg,
    sizeButtonPaddingHorizontalXl: sizeButtonPaddingHorizontalXl,
    sizeSpacing0: sizeSpacing0,
    sizeSpacing1: sizeSpacing1,
    sizeSpacing2: sizeSpacing2,
    sizeSpacing3: sizeSpacing3,
    sizeSpacing4: sizeSpacing4,
    sizeSpacing5: sizeSpacing5,
    sizeSpacing6: sizeSpacing6,
    sizeSpacing7: sizeSpacing7,
    sizeSpacing8: sizeSpacing8,
    sizeTextXs: sizeTextXs,
    sizeTextSm: sizeTextSm,
    sizeTextMd: sizeTextMd,
    sizeTextLg: sizeTextLg,
    sizeTextXl: sizeTextXl,
    sizeFontWeight100: sizeFontWeight100,
    sizeFontWeight200: sizeFontWeight200,
    sizeFontWeight300: sizeFontWeight300,
    sizeFontWeight400: sizeFontWeight400,
    sizeFontWeight500: sizeFontWeight500,
    sizeFontWeight600: sizeFontWeight600,
    sizeFontWeight700: sizeFontWeight700,
    sizeFontWeight800: sizeFontWeight800,
    sizeFontWeight900: sizeFontWeight900
});

var tokens = __assign(__assign({}, colorVariables), sizeVariables);

export default tokens;
//# sourceMappingURL=index.es.js.map
